// The shared supabase-js client, pointed at the active project (STAGING by
// default — see src/config/supabase.js). Import this wherever the app needs to
// talk to Supabase.
//
// NOTE: not yet wired into the live app — Phase 2 builds against this behind the
// stock cut-over. FOH auth uses our own short-lived (~15 min) pass rather than a
// persisted Supabase session, so persistSession is off; when the pass is minted
// we attach it as the Authorization bearer for RLS.
import { createClient } from "@supabase/supabase-js";
import { getSupabaseConfig } from "../config/supabase.js";

const { url, anonKey } = getSupabaseConfig();

export const supabase = createClient(url, anonKey, {
  auth: { persistSession: false, autoRefreshToken: false },
});
